import type { EStatisticsCalculationType } from 'common/enum/misc.enum';

export type AnalysisFilters = {
  classId?: number;
  studentId?: number;
  subjectIds?: number[];
  calculationType?: EStatisticsCalculationType;
  from?: string;
  to?: string;
};

export const analysisKeys = {
  root: ['analysis'],
  subjectScoresList: (filter: AnalysisFilters) => [
    ...analysisKeys.root,
    'subject-scores',
    'list',
    filter.classId,
    filter.studentId,
    filter.subjectIds,
    filter.calculationType,
    filter.from,
    filter.to,
  ],
  subjectScoresCount: (filter: AnalysisFilters) => [
    ...analysisKeys.root,
    'subject-scores',
    'count',
    filter.classId,
    filter.studentId,
    filter.subjectIds,
    filter.calculationType,
    filter.from,
    filter.to,
  ],
  studentSubjectScores: (filter: AnalysisFilters) => [
    ...analysisKeys.root,
    'subject-scores',
    'student',
    filter.classId,
    filter.studentId,
    filter.subjectIds,
    filter.calculationType,
    filter.from,
    filter.to,
  ],
  all: () => analysisKeys.root,
};
